/**
 * Search-related type definitions
 * Centralized types for talent search functionality
 */

export interface Talent {
  id: string;
  username: string;
  name: string;
  title: string;
  location: string;
  experience: number;
  skills: string[];
  avatar: string;
  currentCompany?: string;
  companyLogo?: string;
  education: string;
  isAvailable: boolean;
  lastActive: string;
  projects: number;
  recommendations: number;
  hasInternship: boolean;
  position: string; // Frontend, Backend, DevOps, etc.
}

export interface SearchFilters {
  query: string;
  location: string;
  experience: string;
  skills: string[];
  position: string;
  hasInternship: string;
  availability: string;
  sortBy: string;
  sortOrder: "asc" | "desc";
}

export interface SearchResult {
  talents: Talent[];
  totalCount: number;
  currentPage: number;
  totalPages: number;
}

// Search filter options
export const EXPERIENCE_OPTIONS = [
  { value: "", label: "전체" },
  { value: "0", label: "신입 (0년)" },
  { value: "1-2", label: "1-2년" },
  { value: "3-5", label: "3-5년" },
  { value: "6-10", label: "6-10년" },
  { value: "10+", label: "10년 이상" },
] as const;

export const POSITION_OPTIONS = [
  { value: "", label: "전체" },
  { value: "Frontend", label: "Frontend" },
  { value: "Backend", label: "Backend" },
  { value: "Full Stack", label: "Full Stack" },
  { value: "DevOps", label: "DevOps" },
  { value: "Mobile", label: "Mobile" },
  { value: "Data Science", label: "Data Science" },
] as const;

export const INTERNSHIP_OPTIONS = [
  { value: "", label: "전체" },
  { value: "true", label: "인턴 경험 있음" },
  { value: "false", label: "인턴 경험 없음" },
] as const;

export const AVAILABILITY_OPTIONS = [
  { value: "", label: "전체" },
  { value: "available", label: "구직 중" },
  { value: "unavailable", label: "구직 중 아님" },
] as const;

export const SORT_OPTIONS = [
  { value: "name", label: "이름순" },
  { value: "experience", label: "경력순" },
  { value: "lastActive", label: "최근 활동순" },
  { value: "projects", label: "프로젝트 수순" },
  { value: "recommendations", label: "추천 수순" },
] as const;

export const SORT_ORDER_OPTIONS = [
  { value: "asc", label: "오름차순" },
  { value: "desc", label: "내림차순" },
] as const;
